import React from 'react';
import { Logo } from './Logo';
import { WhatsAppCta } from './WhatsAppCta';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-16" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-14">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-15">
            Ready to Scale Your Business?
          </h2>
          <p className="text-lg mb-8 max-w-2xl" data-id="element-16">
            Join the hundreds of UK businesses growing with Smart Market
            Digital. Get in touch today for a free consultation.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-17">
            <WhatsAppCta size="xl" text="Contact Us on WhatsApp" data-id="element-18" />
            <p className="text-xl font-semibold text-white mt-2" data-id="element-19">
              +44 7921 876472
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-20">
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-21">
            <Logo className="scale-90 origin-left" data-id="element-22" />
            <p className="text-sm" data-id="element-23">
              © {new Date().getFullYear()} Smart Market Digital. All rights
              reserved.
            </p>
          </div>

          <div className="flex gap-6 text-sm" data-id="element-24">
            <a href="#" className="hover:text-green-400 transition-colors" data-id="element-25">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-green-400 transition-colors" data-id="element-26">
              Terms of Service
            </a>
            <a href="#" className="hover:text-green-400 transition-colors" data-id="element-27">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}